import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-ec.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-ec.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ActivatedRoute } from "@angular/router";
import { AppControllerService } from "../../../../../app-controller.service";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { MapService } from "../../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { ViewApplicationService } from "../../../view-application.service";
import { WktConverterUtils } from "../../../../../shared/utils/wkt-converter-utils";
import RecipientUtils from "../../../../../shared/utils/recipient-utils";
import { AlertType } from "../../../../../shared/models/alert";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../../app.config";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
import Query from "@arcgis/core/rest/support/Query";
import { ViewApplicationLocationEcConstants } from "./view-application-location-ec.constants";
import { ElectricalConnectionService } from "../../../../../shared/services/modules/electrical-connection.service";
import { debounceTime } from "rxjs";
import { PopUpComponent } from "../../../../../shared/components/pop-up/pop-up.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { take, takeUntil } from "rxjs/operators";
import { AutoUnsub } from "../../../../../shared/decorators/autounsub.decorator";
let ViewApplicationLocationEcComponent = class ViewApplicationLocationEcComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    modalService;
    appController;
    routerParamsService;
    recipientListService;
    changeDetectorRefs;
    mapService;
    requestStatusService;
    viewApplicationService;
    electricalConnectionService;
    active;
    saveBtnPlaceholder = ViewApplicationLocationEcConstants.SAVE_BUTTON_PLACEHOLDER;
    propertiesForm;
    descriptionLabel1 = ViewApplicationLocationEcConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = ViewApplicationLocationEcConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = ViewApplicationLocationEcConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = ViewApplicationLocationEcConstants.DESCRIPTION_LABEL_4;
    validationMessages = ViewApplicationLocationEcConstants.VALIDATION_MESSAGES;
    erfNoControl = ViewApplicationLocationEcConstants.ERF_NO_CONTROL;
    subdivisionControl = ViewApplicationLocationEcConstants.SUBDIVISION_CONTROL;
    allotmentControl = ViewApplicationLocationEcConstants.ALLOTMENT_CONTROL;
    farmNoControl = ViewApplicationLocationEcConstants.FARM_NO_CONTROL;
    sgCodeControl = ViewApplicationLocationEcConstants.SG_CODE_CONTROL;
    addressControl = ViewApplicationLocationEcConstants.ADDRESS_CONTROL;
    ownerControl = ViewApplicationLocationEcConstants.OWNER_CONTROL;
    erfNoTextPlaceHolder = ViewApplicationLocationEcConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = ViewApplicationLocationEcConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = ViewApplicationLocationEcConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = ViewApplicationLocationEcConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = ViewApplicationLocationEcConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = ViewApplicationLocationEcConstants.ADDRESS_TEXT_PLACEHOLDER;
    copyApplicantToOwnerLabel = ViewApplicationLocationEcConstants.COPY_APPLICANT_TO_OWNER_LABEL;
    modalOptions = ViewApplicationLocationEcConstants.MODAL_OPTION;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    removePropertyLabel = ViewApplicationLocationEcConstants.REMOVE_PROPERTY_LABEL;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerGroups = [];
    ownerLabel = "Owner";
    buildingNamePlaceHolder = ViewApplicationLocationEcConstants.BUILDING_NAME_LABEL;
    floorPlaceholder = ViewApplicationLocationEcConstants.FLOOR_LABEL;
    buildingNameControl = ViewApplicationLocationEcConstants.BUILDING_NAME_CONTROL;
    floorControl = ViewApplicationLocationEcConstants.FLOOR_CONTROL;
    mapComponent;
    application;
    isMapLoaded = false;
    missingOwnerErrMsg = ViewApplicationLocationEcConstants.MISSING_OWNER_IN_PROPERTY;
    getApplicationSetPropertiesObservableSubscription;
    getStepMetaObservableSubscription;
    selectedPropertySubscription;
    constructor(aflaModuleStrategyService, route, modalService, appController, routerParamsService, recipientListService, changeDetectorRefs, mapService, requestStatusService, viewApplicationService, electricalConnectionService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.modalService = modalService;
        this.appController = appController;
        this.routerParamsService = routerParamsService;
        this.recipientListService = recipientListService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.viewApplicationService = viewApplicationService;
        this.electricalConnectionService = electricalConnectionService;
    }
    ngOnInit() {
        this.initForm();
        this.listenForRouteParamChange();
        this.subscribeToProperty();
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
    }
    handleRouteChange() {
        this.initialiseForm();
    }
    onBtnSaveClicked() {
        if (this.propertiesForm.valid) {
            const points = [];
            const properties = [];
            let ownerMissingInProperty = false;
            const propertiesArray = this.getProperties();
            for (const item of propertiesArray.controls) {
                const centroid = item.get("centroid").value;
                points.push(`(${centroid.x} ${centroid.y})`);
                const geometry = item.get("geometry").value;
                const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
                const owners = item.get("owners").value.recipients;
                if (owners.length > 0) {
                    owners.forEach((owner) => {
                        owner = RecipientUtils.removeRecipientProperties(owner);
                    });
                }
                else {
                    ownerMissingInProperty = true;
                    this.appController.showMessage(this.missingOwnerErrMsg, AlertType.Warning);
                    break;
                }
                let property = null;
                if (item.get("property") !== null && item.get("property").value !== null) {
                    property = item.get("property").value;
                    property.address = item.get("address").value;
                    property.allotment = item.get("allotment").value;
                    property.erfNumber = item.get("erfNo").value;
                    property.farmNumber = item.get("farmNo").value;
                    property.sgCode = item.get("sgCode").value;
                    property.buildingName = item.get("buildingName").value;
                    property.floor = item.get("floor").value;
                    property.subdivision = item.get("subdivision").value;
                    property.owners = owners;
                }
                else {
                    property = {
                        address: item.get("address").value,
                        allotment: item.get("allotment").value,
                        erfNumber: item.get("erfNo").value,
                        farmNumber: item.get("farmNo").value,
                        buildingName: item.get("buildingName").value,
                        floor: item.get("floor").value,
                        isDummy: false,
                        sgCode: item.get("sgCode").value,
                        shape: geometryJSON,
                        subdivision: item.get("subdivision").value,
                        updateGeometry: false,
                        wkid: 102100,
                        owners,
                    };
                }
                properties.push(property);
            }
            if (!ownerMissingInProperty) {
                const params = {
                    properties,
                    applicationShape: `MULTIPOINT (${points.join(", ")})`,
                    applicationWkid: 102100
                };
                this.getApplicationSetPropertiesObservableSubscription =
                    this.electricalConnectionService.getApplicationSetPropertiesObservable(this.application.id, params)
                        .pipe(takeUntil(this._destroy$), take(1))
                        .subscribe({
                        next: (appSaveresponse) => {
                            this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
                        },
                        error: (error) => {
                            this.appController.handleServerErrorMessage(ViewApplicationLocationEcConstants.STEP_TITLE, error, CRUDOperation.Update);
                        }
                    });
            }
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    getProperties() {
        return this.propertiesForm.get("properties");
    }
    updateRequiredFields(propertyIndex) {
        const propertyControl = this.getProperties().controls[propertyIndex];
        const erfNoControl = propertyControl.get(this.erfNoControl);
        const farmNoControl = propertyControl.get(this.farmNoControl);
        const subdivisionControl = propertyControl.get(this.subdivisionControl);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.clearValidators();
            subdivisionControl.clearValidators();
            farmNoControl.disable();
            subdivisionControl.disable();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") ||
            (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.clearValidators();
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
        }
        else {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            subdivisionControl.enable();
            erfNoControl.markAsUntouched();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        const sgCodeControl = propertyControl.get(this.sgCodeControl);
        if (sgCodeControl.value !== null && sgCodeControl.value !== undefined && sgCodeControl.value !== "") {
            sgCodeControl.disable();
        }
        else {
            sgCodeControl.enable();
        }
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        subdivisionControl.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        this.getProperties().removeAt(propertyIndex);
        this.changeDetectorRefs.detectChanges();
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    hasControlValidator(control) {
        if (control.validator) {
            const validator = control.validator({});
            if (validator && validator.required) {
                return true;
            }
        }
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("propertiesForm");
        this.propertiesForm = form;
        this.active = 0;
    }
    initialiseForm() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    loadMetadata(stepMeta) {
        try {
            this.ownerGroups = stepMeta.ownerGroup;
            if (this.ownerGroups[0].hasOwnProperty("requiredFields") && this.ownerGroups[0].requiredFields !== null) {
                this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(this.ownerGroups);
            }
            this.getApplicantData();
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    getApplicantData() {
        const params = {
            $filter: `jobId eq ${this.jobID} and moduleId eq ${this.moduleID}`,
            $expand: `properties($expand=owners($expand=groups)),applicant($expand=groups)`
        };
        this.aflaModuleStrategyService.getApplicationsQuery(params).pipe(takeUntil(this._destroy$), take(1)).subscribe((returnValue) => {
            const propertyControl = this.getProperties();
            propertyControl.clear();
            this.application = returnValue.value[0];
            this.application.properties.forEach(property => {
                const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(property.shape, 102100);
                const geom = JsonUtils.fromJSON(geometryArc);
                const newProperty = new FormGroup({
                    property: new FormControl(property),
                    erfNo: new FormControl(property.erfNumber, [Validators.required]),
                    subdivision: new FormControl(property.subdivision, [Validators.required]),
                    allotment: new FormControl(property.allotment, [Validators.required]),
                    farmNo: new FormControl(property.farmNumber, [Validators.required]),
                    sgCode: new FormControl(property.sgCode, [Validators.required]),
                    address: new FormControl(property.address, [Validators.required]),
                    geometry: new FormControl(geom),
                    buildingName: new FormControl(property.buildingName),
                    floor: new FormControl(property.floor),
                    centroid: new FormControl(null, [Validators.required]),
                    owners: new FormControl({ recipients: [] }, [Validators.required])
                });
                const ownersControl = newProperty.get("owners");
                this.recipientListService.setRecipients(property.owners, false, ownersControl);
                const proxyUrl = ApiProxyConstants.URL;
                const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
                const url = `${proxyUrl}?${gpToolUrl}`;
                const formData = new FormData();
                formData.append("f", "json");
                formData.append("geometryJSON", JSON.stringify(geometryArc));
                this.viewApplicationService.getTrueCentroid(url, formData)
                    .pipe(takeUntil(this._destroy$), take(1))
                    .subscribe({
                    next: (response) => {
                        newProperty.get("centroid").setValue(response.results[0].value);
                        propertyControl.push(newProperty);
                        this.active = propertyControl.length - 1;
                        this.changeDetectorRefs.detectChanges();
                        this.updateRequiredFields(propertyControl.length - 1);
                        if (this.isMapLoaded) {
                            this.syncMapGeometries();
                        }
                        this.changeDetectorRefs.detectChanges();
                    },
                    error: (error) => {
                        this.appController.handleServerErrorMessage(ViewApplicationLocationEcConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                    }
                });
            });
            if (this.isMapLoaded) {
                this.syncMapGeometries();
            }
            this.changeDetectorRefs.detectChanges();
        });
    }
    checkIfPropertyIsAlreadyLoaded(property) {
        const title = "Replace property";
        const contentMessage = "An application can only have 1 property. Do you want to replace the current property?";
        const propertyControl = this.getProperties();
        if (propertyControl && propertyControl.length > 0) {
            const dialogRef = this.modalService.open(PopUpComponent, this.modalOptions);
            dialogRef.componentInstance.title = title;
            dialogRef.componentInstance.contentMessage = contentMessage;
            dialogRef.componentInstance.data = true;
            dialogRef.result.then((replaceData) => {
                if (replaceData) {
                    this.getProperties().clear();
                    this.mapComponent.clearGraphics("Electrical connection graphics");
                    this.setPropertyData(property.attributes, property.geometry);
                }
            });
        }
        else {
            this.setPropertyData(property.attributes, property.geometry);
        }
    }
    subscribeToProperty() {
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(1000)).subscribe(property => {
            if (property !== null) {
                this.checkIfPropertyIsAlreadyLoaded(property);
            }
        });
    }
    setPropertyData(property, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const sgCode = this.propertyDataAlternateColumnName(property, "SgCode", "sgcode");
        let found = false;
        this.getProperties().controls.forEach(item => {
            const check = item.get("sgCode").value;
            if (check === sgCode) {
                found = true;
                this.appController.showMessage(ViewApplicationLocationEcConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }
        });
        if (!found) {
            const newProperty = new FormGroup({
                erfNo: new FormControl(this.propertyDataAlternateColumnName(property, "ErfNo", "erfno"), [Validators.required]),
                subdivision: new FormControl(this.propertyDataAlternateColumnName(property, "PtnNum", "ptnnum"), [Validators.required]),
                allotment: new FormControl(this.propertyDataAlternateColumnName(property, "Allotment", "allotment"), [Validators.required]),
                farmNo: new FormControl(this.propertyDataAlternateColumnName(property, "FarmNo", "farmno"), [Validators.required]),
                sgCode: new FormControl(this.propertyDataAlternateColumnName(property, "SgCode", "sgcode"), [Validators.required]),
                address: new FormControl(this.propertyDataAlternateColumnName(property, "Address", "address"), [Validators.required]),
                geometry: new FormControl(geometry),
                buildingName: new FormControl(null),
                floor: new FormControl(null),
                centroid: new FormControl(null, [Validators.required]),
                owners: new FormControl(null, [Validators.required])
            });
            const proxyUrl = ApiProxyConstants.URL;
            const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
            const url = `${proxyUrl}?${gpToolUrl}`;
            const formData = new FormData();
            formData.append("f", "json");
            formData.append("geometryJSON", JSON.stringify(geometry));
            this.viewApplicationService.getTrueCentroid(url, formData)
                .pipe(takeUntil(this._destroy$), take(1))
                .subscribe({
                next: (response) => {
                    newProperty.get("centroid").setValue(response.results[0].value);
                    this.getPropertyOwners(sgCode, newProperty);
                },
                error: (error) => {
                    this.requestStatusService.removeBusySpinner("GetPropertyDate");
                    this.appController.handleServerErrorMessage(ViewApplicationLocationEcConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                }
            });
        }
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    getPropertyOwners(sgCode, newProperty) {
        const ownerLayerObj = this.mapService.userMaps.find(a => a.selectionLayerType === "Property owner");
        if (ownerLayerObj !== undefined && ownerLayerObj !== null) {
            const ownerLayer = ownerLayerObj.layer;
            const ownerQuery = new Query();
            ownerQuery.where = `SgCode = '${sgCode}'`;
            ownerQuery.returnGeometry = false;
            ownerQuery.outFields = ["*"];
            ownerLayer.queryFeatures(ownerQuery).then((ownerFeatureSet) => {
                // Make sure the grave centroid is within one cemetery boundary
                const ownersControl = newProperty.get("owners");
                const owners = [];
                if (ownerFeatureSet.features.length > 0) {
                    ownerFeatureSet.features.forEach(item => {
                        try {
                            const newOwner = {
                                name: item.attributes.Name ? item.attributes.Name : item.attributes.name,
                                surname: item.attributes.Surname ? item.attributes.Surname : item.attributes.surname,
                                telephone: item.attributes.Telephone ? item.attributes.Telephone : item.attributes.telephone,
                                email: item.attributes.Email ? item.attributes.Email : item.attributes.email,
                                defaultCommunicationMethod: item.attributes.DefaultCommunicationMethod ? item.attributes.DefaultCommunicationMethod : item.attributes.defaultcommunicationmethod,
                                postalAddress: item.attributes.PostalAddress ? item.attributes.PostalAddress : item.attributes.postaladdress,
                                designation: item.attributes.Designation ? item.attributes.Designation : item.attributes.designation,
                                organisation: item.attributes.Organisation ? item.attributes.Organisation : item.attributes.organisation,
                                clientVatNumber: item.attributes.ClientVatNumber ? item.attributes.ClientVatNumber : item.attributes.clientvatnumber,
                                streetAddress: item.attributes.StreetAddress ? item.attributes.StreetAddress : item.attributes.streetaddress,
                                homePhone: item.attributes.Homephone ? item.attributes.Homephone : item.attributes.homephone,
                                idNumber: item.attributes.IDNumber ? item.attributes.IDNumber : item.attributes.idnumber,
                                organisationRegistrationNumber: item.attributes.OrganisationRegistrationNumber ? item.attributes.OrganisationRegistrationNumber : item.attributes.organisationregistrationnumber,
                                representative: item.attributes.Representative ? item.attributes.Representative : item.attributes.representative,
                                fax: item.attributes.Fax ? item.attributes.Fax : item.attributes.fax,
                                cellphone: item.attributes.Cellphone ? item.attributes.Cellphone : item.attributes.cellphone,
                                streetSuburb: item.attributes.StreetSuburb ? item.attributes.StreetSuburb : item.attributes.streetsuburb,
                                streetCity: item.attributes.StreetCity ? item.attributes.StreetCity : item.attributes.streetcity,
                                streetProvince: item.attributes.StreetProvince ? item.attributes.StreetProvince : item.attributes.streetprovince,
                                streetCode: item.attributes.StreetCode ? item.attributes.StreetCode : item.attributes.streetcode,
                                postalSuburb: item.attributes.PostalSuburb ? item.attributes.PostalSuburb : item.attributes.postalsuburb,
                                postalCity: item.attributes.PostalCity ? item.attributes.PostalCity : item.attributes.postalcity,
                                postalProvince: item.attributes.PostalProvince ? item.attributes.PostalProvince : item.attributes.postalprovince,
                                postalCode: item.attributes.PostalCode ? item.attributes.PostalCode : item.attributes.postalcode,
                                postalCountry: item.attributes.PostalCountry ? item.attributes.PostalCountry : item.attributes.postalcountry,
                                streetCountry: item.attributes.StreetCountry ? item.attributes.StreetCountry : item.attributes.streetcountry,
                                professionalBody: item.attributes.ProfessionalBody ? item.attributes.ProfessionalBody : item.attributes.professionalbody,
                                professionalBodyRegNum: item.attributes.ProfessionalBodyRegistrationNumber ? item.attributes.ProfessionalBodyRegistrationNumber : item.attributes.professionalbodyregistrationumber,
                            };
                            owners.push(newOwner);
                        }
                        catch {
                            this.appController.showMessage(ViewApplicationLocationEcConstants.INVALID_OWNER_ATTRIBUTE, AlertType.Error);
                        }
                    });
                }
                this.recipientListService.setRecipients(owners, false, ownersControl);
                const propertyControl = this.getProperties();
                const propertyIndex = propertyControl.length;
                propertyControl.clear();
                propertyControl.push(newProperty);
                this.active = propertyControl.length - 1;
                this.updateRequiredFields(propertyIndex);
                this.changeDetectorRefs.detectChanges();
                this.syncMapGeometries();
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }, (error) => {
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
                this.appController.showMessage(error.message, AlertType.Error);
            });
        }
        else {
            const propertyControl = this.getProperties();
            const propertyIndex = propertyControl.length;
            propertyControl.push(newProperty);
            this.active = propertyControl.length - 1;
            this.updateRequiredFields(propertyIndex);
            this.changeDetectorRefs.detectChanges();
            this.syncMapGeometries();
            this.requestStatusService.removeBusySpinner("GetPropertyDate");
        }
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Electrical connection graphics", true);
        }
    }
    onBtnCopyApplicantToOwnerClicked(propertyIndex) {
        const applicant = this.application.applicant[0];
        const ownersFormControl = this.getProperties().controls[propertyIndex].get("owners");
        this.recipientListService.addRecipient(applicant, true, ownersFormControl, true);
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: NgbModal },
        { type: AppControllerService },
        { type: RouterParamsService },
        { type: RecipientListService },
        { type: ChangeDetectorRef },
        { type: MapService },
        { type: RequestStatusService },
        { type: ViewApplicationService },
        { type: ElectricalConnectionService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationLocationEcComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-location-ec",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ViewApplicationLocationEcComponent);
export { ViewApplicationLocationEcComponent };
